import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Logs, Meta } from 'utils/types';
import _c from 'utils/constants';
import { logsTransformer } from 'ui/partials/transformers';
import { LOG_TRANSFORMER } from 'ui/partials/transformers/logsTransformer';

import c from '../utils/constants';

interface Result {
  data: { date: number; logs: Logs[] }[];
  meta: Meta;
}

export default function useGetLogs(source: string, id: string) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<LOG_TRANSFORMER[], Error>({
    queryKey: [c.LOGS, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/contacts/${source}/${id}/logs`,
            params: { perPage: _c.OTP_EXPIRY },
            transformer: logsTransformer,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/${source}/${id}/logs`,
            params: { perPage: _c.OTP_EXPIRY },
            transformer: logsTransformer,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
